import React from 'react';
import './about.css'; // Import the CSS file
import Topheader from "../topheader/Topheader";
import Navcivil from "../navbar/Navcivil";
import image from "../../assets/banner-image/WhatsApp Image 2025-02-11 at 1.49.16 PM.jpeg";
import AboutUs from './about';
import  { FaClock, FaMoneyBillWave, FaLeaf, FaShieldAlt, FaLightbulb, FaUsers, FaRegCreditCard, FaFileAlt, FaBullhorn, FaEye, FaListAlt, FaCogs, FaTools, FaGraduationCap } from 'react-icons/fa';
import OurClients from '../our-client/Ourclient';

import VisionMission from '../visionmission/Visionmission';
import Footer from '../footer/Footer';

function Aboutcivil() {
  return (
    <>
      <Topheader />
      <Navcivil />
      <section>
        <div className="image-about">
          {/* Background Image */}
          <img src={image} alt="About Us" className="image-bg" />

          {/* Overlay Content */}
          <div className="overlay-about">
            <h2 className="fade-in-text">About Us</h2>
          </div>
        </div>
      </section>
      <AboutUs/>
      
     
<VisionMission/>

<section className="client-benefits-section">
  <div className="container">
    <div className="client-benefits">
      <h3>Client Benefits</h3>
      <div className="underline-benifit"></div>

      {/* Benefits Grid */}
      <div className="benefits-grid">
        {/* Benefit 1: Expertise & Experience */}
        <div className="benefit-item">
          <FaGraduationCap className="icon-benifit" /> {/* New Icon for Expertise */}
          <h3>Expertise & Experience</h3>
          <p >Backed by 25 years of industry experience, we bring knowledge, innovation, and reliability to every project.</p>
        </div>

        {/* Benefit 2: High-Quality Construction */}
        <div className="benefit-item">
          <FaTools className="icon-benifit" /> {/* New Icon for High-Quality Construction */}
          <h3>High-Quality Construction</h3>
          <p>We use premium materials to ensure durability, safety, and long-lasting results. Superior craftsmanship with fine finishing in every detail.</p>
        </div>

        {/* Benefit 3: On-Time Project Completion */}
        <div className="benefit-item">
          <FaClock className="icon-benifit" />
          <h3>On-Time Project Completion</h3>
          <p>Strict time management ensures your project is completed as scheduled, avoiding unnecessary delays. Well-coordinated team and streamlined workflow for efficient execution.</p>
        </div>

        {/* Benefit 4: Skilled Workforce & Resources */}
        <div className="benefit-item">
          <FaUsers className="icon-benifit" />
          <h3>Skilled Workforce & Resources</h3>
          <p>Large team of trained laborers ensuring seamless project execution. Experienced engineers, architects, and designers for structural and aesthetic excellence.</p>
        </div>

        {/* Benefit 5: Customization & Flexibility */}
        <div className="benefit-item">
          <FaCogs className="icon-benifit" /> {/* New Icon for Customization */}
          <h3>Customization & Flexibility</h3>
          <p>We understand that every client has unique needs and offer tailored solutions for residential and commercial projects. Personalized designs and adaptability to client preferences.</p>
        </div>

        {/* Benefit 6: Cost-Effective Solutions */}
        <div className="benefit-item">
          <FaMoneyBillWave className="icon-benifit" />
          <h3>Cost-Effective Solutions</h3>
          <p>Transparent pricing with no hidden costs. Optimized resources and smart planning to provide value for money.</p>
        </div>

        {/* Benefit 7: End-to-End Services */}
        <div className="benefit-item">
          <FaListAlt className="icon-benifit" /> {/* New Icon for End-to-End Services */}
          <h3>End-to-End Services</h3>
          <p>We handle everything from planning, designing, and construction to interior finishing. Expertise in residential, commercial, showroom, and mall projects.</p>
        </div>

        {/* New Benefit 8: Loan Support */}
        <div className="benefit-item">
          <FaRegCreditCard className="icon-benifit" />
          <h3>Loan Support</h3>
          <p>Assistance with financing options to make your projects affordable.</p>
        </div>

        {/* New Benefit 9: Registration Assistance */}
        <div className="benefit-item">
          <FaFileAlt className="icon-benifit" />
          <h3>Registration Assistance</h3>
          <p>Help with property and legal registrations to streamline the process.</p>
        </div>
      </div>
    </div>
  </div>
</section>

  <OurClients/>
  <section style={{ marginTop:"50px"}}>
        <div className="image-about">
          {/* Background Image */}
          <img src={image} alt="About Us" className="image-bg" />

          {/* Overlay Content */}
          <div className="overlay-chooseus">
             <div className='container'>
            <h2 className="fade-in-text">Why Choose us ?</h2>
            
           
            <p>First Sky Infrastructure , we bring over 25 years of experience in delivering high-quality construction and design solutions. Our end-to-end services ensure that we handle every aspect of your project, from initial design to final execution. With a skilled workforce of trained professionals, we ensure precision, superior craftsmanship, and attention to detail in every project. We use premium materials and modern technologies , guaranteeing durability , safety , and aesthetic appeal . Our commitment to timely delivery and cost-effective pricing ensures that your project is completed on schedule and within budget, with no hidden costs. We prioritize safety and compliance with all regulations and take pride in implementing eco-friendly practices to build sustainable, energy-efficient structures. Trusted by leading brands like Raymond, TCS, Hyundai, and Maruti Suzuki, we provide customized solutions to meet your unique needs and exceed your expectations.</p>
            </div></div>
        </div>
      </section>
  <Footer/>
    </>
  );
}

export default Aboutcivil;
